import Navbar from "../navigation/Navbar";
import { CameraAltOutlined, Close, Edit, KeyboardArrowDown } from "@mui/icons-material";
import "./ProfilePage.scss";
import ProfileImg from '../../images/user/profile-img.png';
import Location from '../../images/user/location.png';
import Email from '../../images/user/mail.png';
import Phone from '../../images/user/phone.png';
import { Accordion, AccordionDetails, AccordionSummary, LinearProgress } from "@mui/material";
import toList from "../utils/ComponentUtil";
import CustomAccordion from "../utils/CustomAccordion";
import { Link } from "react-router-dom";
import ProfileAPI from "../Apis/ProfileAPI";
import ExpandMoreIcon from "../utils/ExpandMoreIcon";

function ProfilePage() {
    const settings = ProfileAPI.getSetting();
    const profile = {
        completed: ProfileAPI.profileCompleted(),
        profilePic: ProfileImg,
        details: [
            {
                icon: Location,
                name: 'Location',
                value: settings?.categories[0]?.data?.[0]?.city?.value
            },
            {
                icon: Email,
                name: 'Email',
                value: settings?.categories[0]?.data?.[0]?.email?.value
            },
            {
                icon: Phone,
                name: 'Phone',
                value: settings?.categories[0]?.data?.[0]?.contact?.value
            }
        ],
        description: settings?.categories[0]?.data?.[0]?.about?.value,
        skills: settings?.categories[3]?.data?.[0]?.skills?.value,
        contents: [
            {
                name: 'Work Experience',
                to: '/setting/experiences',
                details: settings?.categories[1]?.data?.map(e => {
                    return {
                        title: e.title.value,
                        subTitle: e.company.value,
                        text: e.dateOfJoining.value + ' - ' + (e.workedTill.value ? e.workedTill.value : 'Present')
                    }
                })
            },
            {
                name: 'Education Details',
                to: '/setting/education',
                details: settings?.categories[2]?.data?.map(e => {
                    return {
                        title: e.college.value,
                        subTitle: e.degree.value,
                        text: e.year.value
                    }
                })
            },
            {
                name: 'Certifications',
                to: '/setting/certifications',
                details: settings?.categories[4]?.data?.map(e => {
                    return {
                        title: e.course.value,
                        subTitle: e.certificateFrom.value,
                        text: e.issuedOn.value + ' - ' + (e.expiresOn.value ? e.expiresOn.value : 'No Expiration')
                    }
                })
            },
            {
                name: 'Portfolio',
                to: '/setting/portfolios',
                details: settings?.categories[5]?.data?.[0]?.portfolios?.value?.map(e => {
                    return {
                        title: e.type,
                        text: e.value
                    }
                })
            }
        ]

    }

    return (
        <>
            <Navbar></Navbar>
            <div className="profile-details-wrp wrapper">
                <div className="left-wrp">
                    <div className="details-container-wrp">
                        <div className="profile-completed">
                            <div className="completed-details">
                                <div className="left">Profile Completed</div>
                                <div className="right">{profile?.completed}%</div>
                            </div>
                            <LinearProgress className="progress-bar" variant="determinate" value={profile?.completed} />
                        </div>
                        <div className="profile-pic-wrp">
                            <div className="profile-img-wrp">
                                <img className="profile-img" src={profile?.profilePic} alt="profile-img" />
                                <Link reloadDocument={true} to={'/setting/personal-info'} ><CameraAltOutlined className="choose-profile-wrp"></CameraAltOutlined></Link>
                            </div>
                            <div className="profile-name-wrp">
                                <div className="name-container">
                                    <div className="name">Bruce Wayne</div>
                                    <Link reloadDocument={true} to={'/setting/personal-info'} > <Edit className='edit-icon' /></Link>
                                </div>
                                <div className="skill">UI/UX Designer</div>
                            </div>
                        </div>
                        <div className="details-wrp">
                            {
                                toList(profile?.details, undefined, (item, i) =>
                                    <div className="detail-wrp" key={i}>
                                        <div className="name-wrp">
                                            <img className="icon-img" src={item.icon} alt="icon-img" />
                                            <div className="name">{item.name}</div>
                                        </div>
                                        <div className="value">{item.value}</div>
                                    </div>)
                            }
                        </div>
                        <div className="description-wrp">
                            <div className="item-header">
                                <div className="item">Description</div>
                                <Link reloadDocument={true} to={'/setting/personal-info'} > <Edit className='edit-icon' /></Link>
                            </div>
                            <div className="details">{profile?.description}</div>
                        </div>
                        <div className="skills-wrp">
                            <div className="item-header">
                                <div className="item">Skills</div>
                                <Link reloadDocument={true} to={'/setting/skills'} > <Edit className='edit-icon' /></Link>
                            </div>
                            <div className="all-skills-wrp">
                                {
                                    toList(profile?.skills, undefined, (item, i) =>
                                        <div className="skill" key={i}>
                                            <div className="name">{item}</div>
                                            <Close className="close-icon" />
                                        </div>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right-wrp">
                    <div className="details-wrp">
                        {toList(profile?.contents, undefined, (item, i) =>
                            <Accordion defaultExpanded={true}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <div className="detail-header-wrp">
                                        <div className="header-wrp">
                                            <div className="name">{item.name}</div>
                                            <Link reloadDocument={true} to={item?.to} > <Edit className='edit-icon' /></Link>
                                            <KeyboardArrowDown className="arrow-icon" />
                                        </div>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="contents-wrp">
                                        {
                                            toList(item?.details, undefined, (element, j) =>
                                                <div className="content-wrp" key={j}>
                                                    <div className="title">{element?.title}</div>
                                                    <div className="sub-title">{element?.subTitle}</div>
                                                    <div className="info">{element?.text}</div>
                                                </div>)
                                        }
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProfilePage;
